import { TableCell, TableRow } from '@ovComponents/2-component/table/table';
import { Box, Button, Typography, useTheme } from 'hephaestus/web';
import { useTranslation } from 'react-i18next';
import { SECONDARY_TEXT_SX } from '../styles';
export type PortfoliosTablePageLoadErrorProps = {
  colSpan: number;
  page: number;
  pageGraphQLErrors: string[];
  onRetryPage: () => void;
  onGoBackPage: () => void;
};

export const PortfoliosTablePageLoadError = ({
  colSpan,
  page,
  pageGraphQLErrors,
  onRetryPage,
  onGoBackPage,
}: PortfoliosTablePageLoadErrorProps) => {
  const theme = useTheme();
  const { t } = useTranslation('portfolioTradingHub');

  return (
    <TableRow>
      <TableCell colSpan={colSpan}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 1,
            py: 3,
            px: 2,
          }}
        >
          <Typography
            variant='labelSmall'
            sx={{
              color: theme.color.negative,
              fontWeight: 600,
              textAlign: 'center',
            }}
          >
            {t('portfoliosTable.pageLoadErrorTitle')}
          </Typography>
          <Typography
            variant='labelSmall'
            sx={{
              ...SECONDARY_TEXT_SX,
              textAlign: 'center',
              maxWidth: 640,
            }}
          >
            {t('portfoliosTable.pageLoadErrorDescription', { page })}
          </Typography>
          {pageGraphQLErrors.length > 0 && (
            <Typography
              variant='labelSmall'
              sx={{
                ...SECONDARY_TEXT_SX,
                fontFamily: 'monospace',
                textAlign: 'center',
                maxWidth: 720,
                wordBreak: 'break-word',
              }}
            >
              {pageGraphQLErrors.join(' • ')}
            </Typography>
          )}
          <Box
            sx={{
              display: 'flex',
              gap: 1,
              mt: 0.5,
            }}
          >
            <Button variant='outlined' size='small' onClick={onRetryPage}>
              {t('portfoliosTable.retryThisPage')}
            </Button>
            {page > 1 && (
              <Button variant='text' size='small' onClick={onGoBackPage}>
                {t('portfoliosTable.goBackPage')}
              </Button>
            )}
          </Box>
        </Box>
      </TableCell>
    </TableRow>
  );
};
